import { useApp } from '@/hooks/use-app-context';
import { useToast } from '@/hooks/use-toast';
import { AdminAccessStatus } from '@/components/settings';
import { ContributePageHeading } from '@/components/contribute/ContributePageHeading';
import { BecomeAdminView, buildBecomeAdminSteps, useBecomeAdminForm } from '@/features/become-admin';

export default function BecomeAdmin() {
  const { t, user, language } = useApp();
  const { toast } = useToast();
  if (user?.role === "admin" || user?.role === "super_admin") {
    return (
      <div className="min-h-screen bg-background">
        <div className="mx-auto max-w-4xl space-y-9 px-4 py-8 sm:px-6 sm:py-10 lg:py-12">
          <ContributePageHeading
            eyebrow={t.becomeAdminEyebrow}
            title={t.settingsAdminAccessTitle}
            description={t.settingsAdminAccessDescription}
            titleClassName="text-3xl sm:text-4xl"
          />
          <AdminAccessStatus
            roleLabel={user.role === "super_admin" ? t.admin.layout.roles.super_admin : t.admin.layout.roles.admin}
            title={t.settingsAdminAccessTitle}
            description={t.settingsAdminAccessDescription}
            badge={t.settingsAdminAccessBadge}
            actionLabel={t.settingsAdminAccessAction}
            onOpen={() => window.location.assign("/" + language + "/admin/dashboard")}
          />
        </div>
      </div>
    );
  }
  const steps = buildBecomeAdminSteps(t);
  const form = useBecomeAdminForm({ t, user, toast });

  return <BecomeAdminView form={form} steps={steps} t={t} />;
}
